var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerCookie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.703,
    height: 19.703,
    viewBox: "0 0 19.703 19.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_859",
    "data-name": "\\uADF8\\uB8F9 859",
    transform: "translate(-408 -18.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_99",
    "data-name": "\\uD0C0\\uC6D0 99",
    cx: 7.389,
    cy: 7.389,
    r: 7.389,
    transform: "translate(410.463 21.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-cookie",
    "data-name": "Icon awesome-cookie",
    d: "M19.639,9.805l-.465-2.935a5.1,5.1,0,0,0-1.43-2.807L15.637,1.956A5.08,5.08,0,0,0,12.839.53L9.887.063a5.075,5.075,0,0,0-3.1.491L4.129,1.909A5.089,5.089,0,0,0,1.905,4.133L.555,6.784A5.1,5.1,0,0,0,.061,9.9l.465,2.935a5.1,5.1,0,0,0,1.43,2.807l2.107,2.107a5.083,5.083,0,0,0,2.8,1.426l2.952.467a5.077,5.077,0,0,0,3.1-.491l2.66-1.355a5.091,5.091,0,0,0,2.224-2.224l1.351-2.65a5.106,5.106,0,0,0,.493-3.116ZM6.772,14.162A1.231,1.231,0,1,1,8,12.931,1.232,1.232,0,0,1,6.772,14.162ZM8,8A1.231,1.231,0,1,1,9.235,6.773,1.232,1.232,0,0,1,8,8Zm6.157,4.926A1.231,1.231,0,1,1,15.392,11.7,1.232,1.232,0,0,1,14.16,12.931Z",
    transform: "translate(408.002 18.5)",
    fill: "#ffd8ac"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_100",
    "data-name": "\\uD0C0\\uC6D0 100",
    cx: 0.616,
    cy: 0.616,
    r: 0.616,
    transform: "translate(421.546 22.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_101",
    "data-name": "\\uD0C0\\uC6D0 101",
    cx: 0.616,
    cy: 0.616,
    r: 0.616,
    transform: "translate(419.083 35.125)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_102",
    "data-name": "\\uD0C0\\uC6D0 102",
    cx: 0.616,
    cy: 0.616,
    r: 0.616,
    transform: "translate(409.231 27.736)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_103",
    "data-name": "\\uD0C0\\uC6D0 103",
    cx: 0.616,
    cy: 0.616,
    r: 0.616,
    transform: "translate(417.852 27.736)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_104",
    "data-name": "\\uD0C0\\uC6D0 104",
    cx: 0.616,
    cy: 0.616,
    r: 0.616,
    transform: "translate(415.389 20.347)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCookie);
export default __webpack_public_path__ + "static/media/marker_cookie.887b8d8fd1eb2d225d1d3110374757ab.svg";
export { ForwardRef as ReactComponent };